export default "__VITE_ASSET__c03e5c57__"